export enum AccessModes {
  DEFAULT = 'DEFAULT',
  EDITOR = 'EDITOR',
  OWNER = 'OWNER',
  VIEWER = 'VIEWER',
  COLLECTION_EDITOR = 'COLLECTION_EDITOR',
  COLLECTION_OWNER = 'COLLECTION_OWNER',
  COLLECTION_VIEWER = 'COLLECTION_VIEWER',
  MOCKUP_OWNER = 'MOCKUP_OWNER',
  MOCKUP_EDITOR = 'MOCKUP_EDITOR',
  MOCKUP_VIEWER = 'MOCKUP_VIEWER',
  DEVICE_DESKTOP = 'DEVICE_DESKTOP',
  DEVICE_MOBILE = 'DEVICE_MOBILE',
  PUBLIC_USER = 'PUBLIC_USER',
  LICENSED_USER = 'LICENSED_USER',
}

export const AccessModesGroups = {
  USER_PERMISSION: [AccessModes.OWNER, AccessModes.EDITOR, AccessModes.VIEWER],
  COLLECTION_PERMISSION: [
    AccessModes.COLLECTION_OWNER,
    AccessModes.COLLECTION_EDITOR,
    AccessModes.COLLECTION_VIEWER,
  ],
  MOCKUP_PERMISSION: [
    AccessModes.MOCKUP_OWNER,
    AccessModes.MOCKUP_EDITOR,
    AccessModes.MOCKUP_VIEWER,
  ],
  DEVICE_PERMISSION: [AccessModes.DEVICE_DESKTOP, AccessModes.DEVICE_MOBILE],
  PUBLIC_PERMISSION: [AccessModes.PUBLIC_USER, AccessModes.LICENSED_USER],
};

export enum AccessModesActions {
  EDIT_STYLE = 'EDIT_STYLE',
  IMPORT_LOGO = 'IMPORT_LOGO',
  EDIT_LOGOS = 'EDIT_LOGOS',
  SHARE_AS_EDITOR = 'SHARE_AS_EDITOR',
  SHARE_AS_VIEWER = 'SHARE_AS_VIEWER',
  NEW_PRODUCT = 'NEW_PRODUCT',
  CHANGE_STYLE = 'CHANGE_STYLE',
  UPDATE_PREVIEW = 'UPDATE_PREVIEW',
  CHANGE_MOCKUP_NAME = 'CHANGE_MOCKUP_NAME',
  CREATE_COLLECTION = 'CREATE_COLLECTION',
  EDIT_COLLECTION = 'EDIT_COLLECTION',
  REMOVE_COLLECTION = 'REMOVE_COLLECTION',
  CREATE_PRODUCT = 'CREATE_PRODUCT',
  EDIT_PRODUCT = 'EDIT_PRODUCT',
  REMOVE_PRODUCT = 'REMOVE_PRODUCT',
  SHOW_LIBRARY = 'SHOW_LIBRARY',
  SHOW_HOME = 'SHOW_HOME',
  SHOW_SETTINGS = 'SHOW_SETTINGS',
  SHOW_SHARE = 'SHOW_SHARE',
  SHOW_BATCH_CREATE = 'SHOW_BATCH_CREATE',
  SHOW_EXPORT_DROPDOWN = 'SHOW_EXPORT_DROPDOWN',
  SHOW_USER_AVATAR = 'SHOW_USER_AVATAR',
  SHOW_BACK_ARROW_TOP_BAR = 'SHOW_BACK_ARROW_TOP_BAR',
  FREE_COMMENT = 'FREE_COMMENT',
}
